// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"135":"320628822679a49d","354":"4e00006316b76e93","2537":"575f0e80f313c214","4368":"4f34b61beea3f3ce","8095":"66fed740e0a69d5c"}[chunkId] + ".css";
};